import { Box, CircularProgress, Typography } from "@mui/material";
import "../../assets/styles/common.css";

const TableCard = ({ image, count, text, customStyle, loading }) => {
  return (
    <>
      <Box className="dashboard_card" sx={{ margin: customStyle }}>
        <Box className="card_header">
          {image ? image : ""}
          <Typography className="count">
            {loading === "loading" ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 50,
                }}
              >
                <CircularProgress size={30} color="info" />
              </Box>
            ) : (
              count
            )}
          </Typography>
        </Box>
        <Typography className="foot_text">{text}</Typography>
      </Box>
    </>
  );
};

export default TableCard;
